import styled from 'styled-components';
import { MarginBottom16 } from '../margins';

export const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    ${MarginBottom16};
`;